import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { NavLink } from "react-router-dom";

import CollapseArrowIcon from "@ui/collapseArrowIcon";

export default class Item extends Component {
  static propTypes = {
    children: PropTypes.node,
    icon: PropTypes.node,
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
  }

  state = {
    isExpanded: false,
    lastAction: null
  }

  onToggleButtonClick = (event) => {
    event.preventDefault();

    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }));
  };

  onFocus = () => this.setState({ lastAction: "focus" });

  onClick = () => this.setState({ lastAction: "activate" });

  render() {
    const {
      children, icon, label, to
    } = this.props;
    const { lastAction, isExpanded } = this.state;

    // If the user has focused the item, it should expand to show the label.
    // The label should remain hidden after being activated until the user focuses the item again.
    const shouldHideLabel = lastAction === "activate";
    const hasChildren = React.Children.count(children) > 0;
    const isExternalLink = to.startsWith("https://");

    const navigationMenuClassName = classNames(
      "Navigation__menu__item",
      {
        "Navigation__menu__item--hasChildren": hasChildren,
        "Navigation__menu__item--isExpanded": isExpanded,
        "Navigation__menu__item--hideLabel": shouldHideLabel
      },
    );
    const collapseIcon = (
      <button
        onClick={this.onToggleButtonClick}
        className="Navigation__menu__item__toggle"
      >
        <CollapseArrowIcon width={36} height={36} isToggled={isExpanded} />
      </button>
    );

    return (
      <li className={navigationMenuClassName}>
        {isExternalLink ? (
          <a
            href={to}
            className="nav-external-link"
          >
            {icon}
            <div className="nav-label">{label}</div>
          </a>
        ) : (
            <>
              <NavLink
                to={to}
                onFocus={this.onFocus}
                onClick={this.onClick}
              >
                {icon}
                <div className="nav-label">{label}</div>
                {hasChildren && collapseIcon}
              </NavLink>
              {hasChildren && (
                <ul>
                  {children}
                </ul>
              )}
            </>
        )}
      </li>
    );
  }
}
